export default "__VITE_ASSET__DLM7gr_8__"